import * as AccordionPrimitive from "@radix-ui/react-accordion";
import * as React from "react";

import { ChevronRight } from "@/assets/icons";
import { generateValidClassNameHandler } from "@/lib/utils";

const Accordion = AccordionPrimitive.Root;

const AccordionItem = React.forwardRef<
    React.ElementRef<typeof AccordionPrimitive.Item>,
    React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({
    className,
    ...props
}, ref) => (
    <AccordionPrimitive.Item
        ref={ref}
        className={generateValidClassNameHandler(
            className,
        )}
        {...props}
    />
));

AccordionItem.displayName = "AccordionItem";

export interface AccordionTriggerProps extends React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger> { withoutTriggerArrow?: boolean }

const AccordionTrigger = React.forwardRef<
    React.ElementRef<typeof AccordionPrimitive.Trigger>,
    AccordionTriggerProps
>(({
    children,
    className,
    withoutTriggerArrow,
    ...props
}, ref) => (
    <AccordionPrimitive.Header className="flex">
        <AccordionPrimitive.Trigger
            ref={ref}
            className={generateValidClassNameHandler(
                "w-full flex flex-row justify-start gap-2 items-center text-xs font-medium transition-all [&[data-state=open]>svg]:rotate-90",
                className,
            )}
            {...props}
        >
            {!withoutTriggerArrow && <ChevronRight className="size-4 shrink-0 transition-transform duration-200" />}
            {children}
        </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
));

AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = React.forwardRef<
    React.ElementRef<typeof AccordionPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({
    children,
    className,
    ...props
}, ref) => (
    <AccordionPrimitive.Content
        className="overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
        ref={ref}
        {...props}
    >
        <div
            className={generateValidClassNameHandler(
                "flex flex-col gap-4 text-balance pt-2 md:pt-4",
                className,
            )}
        >
            {children}
        </div>
    </AccordionPrimitive.Content>
));

AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
};
